import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    UiContentWr,
    UiContentCol,
    UiColTitleWr,
    UiColTitle,
} from "../../../_uiComponents/common/UiPageElements";
import UiContentCard from "../../../../components/_uiComponents/cards/UiContentCard";
import {
    UiCol,
    UiRowContainer,
    UiSingleRow,
} from "../../../_uiComponents/grid-container/GridContainer";
import { campaignGetLatestCampaignRequest } from "../../../../_redux/_actions";
import { cardTypes } from "../../../../_redux/_constants";
import { UiSlider } from "../../../_uiComponents/common/UiSlider";
import {
    UiNextArrow,
    UiPrevArrow,
} from "../../../_uiComponents/common/UiSliderArrows";
import { UiContentColWithSlider } from "../../../_uiComponents/common/UiPageElements";
import { isMobile } from "react-device-detect";
import {
    LOCATION_FROM,
    routeLocationLocalStorage,
} from "../../../../_redux/_constants";
import Slide01 from "../../../../styles/img/latest-campaign-slide1.png";
import Slide02 from "../../../../styles/img/latest-campaign-slide2.png";
import Placeholder from "../../../../styles/img/campaign-placeholder.png";
import Slide03 from "../../../../styles/img/q2-wear.png";
import Q4WearTear from "../../../../styles/img/custom/q4-wear-tear-campaign-slider.png";
import Q4Castrol from "../../../../styles/img/custom/q4-castrol-campaign-slider.png";
import CastrolCampaign from "../../../../styles/img/castrol-oil-camp.png";
import WinterCampaign from "../../../../styles/img/winter-campaign-slider.png";
import GoldRushNov from "../../../../styles/img/tlc/campaign-slider-gold-nov.png";
import GoldRushDec from "../../../../styles/img/tlc/campaign-slider-gold-dec.png";
import GoldRushJan from "../../../../styles/img/tlc/gold-rush-campaign-jan-slider.png";
import GoldRushFeb from "../../../../styles/img/tlc/gold-rush-feb-camp-slider.png";
import WearTearJanuary from "../../../../styles/img/custom/wear-tear-jan-campaign-slider.png";
import SpinWinCampaignBanner from "../../../../styles/img/custom/winsday/winsday-campaign-slider.png";
import ServiceStarsCampBanner from "../../../../styles/img/custom/service-stars-campaign-slider.png";
import AlpineCustomer from "../../../../styles/img/custom/alpine/current-campaigns.png";
import AbuDhabiItinerary from "../../../../styles/img/custom/abu-dhabi-winners/abu-dhabi-itinerary-hom.png";
import WearTearFebImg from "../../../../styles/img/custom/feb-wear-tear/current-campaigns.png";
import SaWearTear from "../../../../styles/img/custom/campaigns/2025/march-wear-tear/current-campaigns.png";
import TradePartsManagerImg from "../../../../styles/img/trade-parts-manager/campaign-slider-banner.png";
import {
    userTypes,
    participantJobRoleIds,
    participantTypeIds,
} from "../../../../_redux/_constants";
import Gold from "../../../../styles/img/tlc/campaign-slider-gold.png";
import CastrolMotoGp from "../../../../styles/img/custom/castrol-moto-gp/current-campaigns.png";
import GoldTickets from "../../../../styles/img/custom/golden-tickets/current-campaigns.png";
import GoldRushMarch from "../../../../styles/img/tlc/2025/march/campaign-tlc-slider.png";
import QtwoCampaign from "../../../../styles/img/custom/campaigns/2025/q2-wear-tear/current-campaigns.png"
import WearTearSm from "../../../../styles/img/custom/campaigns/2025/march-wear-tear/sm-current-campaigns.png";
import TradePartsTlc from "../../../../styles/img/tlc/2025/tpm/current-campaigns.png"
import TlcGoldApril from "../../../../styles/img/tlc/2025/april/campaign-slider.png"
import TlcGoldMay from "../../../../styles/img/tlc/2025/may/current-campaigns.png"
import FullThrottleCamp from "../../../../styles/img/custom/campaigns/2025/full-throttle/current-campaigns.png"
import MayGoldTicket from "../../../../styles/img/custom/campaigns/2025/may-golden-ticket/current-campaigns.png"

export default function CurrentCampaigns() {
    const actionDispatch = useDispatch();
    let navigate = useNavigate();

    const { latestAchievements, thingsToDo, auth } = useSelector((state) => {
        return {
            auth: state.auth,
        };
    });

    // const { campaign } = useSelector((state) => {
    //     return {
    //         campaign: state.campaign,
    //     };
    // });

    useEffect(function () {
        // actionDispatch(
        //     campaignGetLatestCampaignRequest({
        //         pageNumber: 1,
        //         pageSize: 20,
        //         type: 0,
        //     }),
        // );
    }, []);

    const tradePartsManagerCampaigns = [
        {
            id: 34,
            campaignId: "330",
            jobRole: "",
            campaignName: "Q2 Mechanical Parts Incentive",
            campaignType: "Incentive",
            description:
                "Top the leaderboard this Quarter and earn a staggering £450 with Mechanical Parts!",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${FullThrottleCamp}`,
        },
        {
            id: 31,
            campaignId: "314",
            jobRole: "Trade Parts Manager",
            campaignName: "Incentive 2025",
            campaignType: "Incentive",
            description:
                "Earn a whopping £225 each quarter when you hit Diamond!",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${TradePartsManagerImg}`,
        },
        {
            id: 32,
            campaignId: "278",
            jobRole: "",
            campaignName: "TLC Gold Rush",
            campaignType: "Incentive",
            description:
                "Boost Engagement & Drive Rewards: Your Guide to Tracking and Maximising Customer Participation in the Monthly Trade Loyalty Club Incentive!",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${TradePartsTlc}`,
        },
      
        {
            id: 33,
            campaignId: "",
            campaignName: "",
            campaignType: "",
            description: "",
            jobRole: "",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${Placeholder}`,
            incentiveType: "",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2023-10-15T00:00:00",
            status: 1,
        },
    ];

    const tlcCustomerCampaigns = [
        {
            id: 20,
            campaignId: "283",
            jobRole: "",
            campaignName: "May Trade Loyalty Incentive",
            campaignType: "Incentive",
            description:
                "Will May be your first golden breakthrough—or the next big win in your unstoppable Trade Loyalty streak?",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${TlcGoldMay}`,
        },
        {
            id: 19,
            campaignId: "282",
            jobRole: "",
            campaignName: "April Trade Loyalty Incentive",
            campaignType: "Incentive",
            description:
                "The GoldRush continues! Don't miss your share of the Gold level money this April?",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${TlcGoldApril}`,
        },
        {
            id: 18,
            campaignId: "276",
            jobRole: "",
            campaignName: "March Trade Loyalty Incentive",
            campaignType: "Incentive",
            description:
                "The GoldRush continues! How much will you earn in March?",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${GoldRushMarch}`,
        },
        {
            id: 17,
            campaignId: "275",
            jobRole: "",
            campaignName: "February Trade Loyalty Incentive",
            campaignType: "Incentive",
            description:
                "Great news! The Goldrush incentive is rolling into February 2025!",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${GoldRushFeb}`,
        },
        {
            id: 16,
            campaignId: "268",
            jobRole: "",
            campaignName: "January Gold Rush Incentive ",
            campaignType: "Incentive",
            description:
                "Start 2025 strong, aim for the gold, and let every purchase count towards January rewards with Renault Parts.",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${GoldRushJan}`,
        },
        {
            id: 13,
            campaignId: "266",
            jobRole: "",
            campaignName: "December Gold Rush Incentive ",
            campaignType: "Incentive",
            description:
                "Close the year with golden rewards for maximising your Renault Group Parts purchases",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${GoldRushDec}`,
        },
        {
            id: 11,
            campaignId: "265",
            jobRole: "",
            campaignName: "November Gold Rush Incentive ",
            campaignType: "Incentive",
            description:
                "Aim high with Renault Group Parts purchases for big rewards in Quarter 4",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${GoldRushNov}`,
        },
        {
            id: 10,
            campaignId: "260",
            jobRole: "",
            campaignName: "October Trade Loyality Incentive ",
            campaignType: "Incentive",
            description:
                "Customers can earn monthly TLC points rewards for achieving trade loyalty target",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${Gold}`,
        },
    ];

    const tlcManagerCampaigns = [
        {
            id: 20,
            campaignId: "283",
            jobRole: "",
            campaignName: "May Trade Loyalty Incentive",
            campaignType: "Incentive",
            description:
                "Will May be your first golden breakthrough—or the next big win in your unstoppable Trade Loyalty streak?",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${TlcGoldMay}`,
        },
        {
            id: 19,
            campaignId: "282",
            jobRole: "",
            campaignName: "April Trade Loyalty Incentive",
            campaignType: "Incentive",
            description:
                "The GoldRush continues! Don't miss your share of the Gold level money this April?",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${TlcGoldApril}`,
        },
        {
            id: 18,
            campaignId: "276",
            jobRole: "",
            campaignName: "March Trade Loyalty Incentive",
            campaignType: "Incentive",
            description:
                "The GoldRush continues! How much will you earn in March?",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${GoldRushMarch}`,
        },
        {
            id: 17,
            campaignId: "275",
            jobRole: "",
            campaignName: "February Trade Loyalty Incentive",
            campaignType: "Incentive",
            description:
                "Great news! The Goldrush incentive is rolling into February 2025!",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${GoldRushFeb}`,
        },
        {
            id: 16,
            campaignId: "268",
            jobRole: "",
            campaignName: "January Gold Rush Incentive ",
            campaignType: "Incentive",
            description:
                "Start 2025 strong, aim for the gold, and let every purchase count towards January rewards with Renault Parts.",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${GoldRushJan}`,
        },
        {
            id: 13,
            campaignId: "266",
            jobRole: "",
            campaignName: "December Gold Rush Incentive ",
            campaignType: "Incentive",
            description:
                "Close the year with golden rewards for maximising your Renault Group Parts purchases",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${GoldRushDec}`,
        },
        {
            id: 11,
            campaignId: "265",
            jobRole: "",
            campaignName: "November Gold Rush Incentive ",
            campaignType: "Incentive",
            description:
                "Aim high with Renault Group Parts purchases for big rewards in Quarter 4",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${GoldRushNov}`,
        },
        {
            id: 10,
            campaignId: "260",
            jobRole: "",
            campaignName: "Q4 Trade Loyality Incentive ",
            campaignType: "Incentive",
            description:
                "Your customers can earn monthly TLC points rewards for achieving trade loyalty targets",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${Gold}`,
            incentiveType: "Hit & Win",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2023-10-15T00:00:00",
            status: 1,
        },
    ];

    const campaignServices = [
        // {
        //     id: 43,
        //     campaignId: "360",
        //     jobRole: "",
        //     campaignName: "May's Golden Ticket Madness",
        //     campaignType: "Incentive",
        //     description:
        //         "Service Managers Power Up - Win lots of Équipe points this May on our Golden Ticket Scratchcard!",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${MayGoldTicket}`,
        //     incentiveType: "Hit & Win",
        //     isApproved: true,
        //     rating: 0,
        //     ratingCount: 0,
        //     startDate: "2023-10-15T00:00:00",
        //     status: 1,
        // },
        {
            id: 42,
            campaignId: "318",
            jobRole: "",
            campaignName: "Q2 Service Advisor Wear & Tear Incentive",
            campaignType: "Incentive",
            description:
                "Get ready for a chance to rack up £40 a month in Équipe points and snag a £500 star prize!",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${QtwoCampaign}`,
            incentiveType: "Hit & Win",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2023-10-15T00:00:00",
            status: 1,
        },
        
        {
            id: 40,
            campaignId: "315",
            jobRole: "",
            campaignName: "Service Advisor Wear & Tear Incentive",
            campaignType: "Incentive",
            description:
                "The campaign is now CLOSED and final results have been published",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${SaWearTear}`,
            incentiveType: "Hit & Win",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2023-10-15T00:00:00",
            status: 1,
        },

       
        
        {
            id: 30,
            campaignId: "125",
            jobRole: "",
            campaignName: "Castrol Winsdays",
            campaignType: "Incentive",
            description:
                "Win up to £50 in points PLUS the chance to win £100 airbnb vouchers!",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${SpinWinCampaignBanner}`,
            incentiveType: "Hit & Win",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2023-10-15T00:00:00",
            status: 1,
        },
        
        
        {
            id: 29,
            campaignId: "313",
            jobRole: "February",
            campaignName: "Wear & Tear Incentive",
            campaignType: "Incentive",
            description:
                "The campaign is now closed and final results have been published",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${WearTearFebImg}`,
            incentiveType: "Hit & Win",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2023-10-15T00:00:00",
            status: 1,
            closed:true
        },
       
    ];

    const campaigns = [
        {
            id: 44,
            campaignId: "360",
            jobRole: "",
            campaignName: "May's Golden Ticket Madness",
            campaignType: "Incentive",
            description:
                "Service Managers Power Up - Win lots of Équipe points this May on our Golden Ticket Scratchcard!",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${MayGoldTicket}`,
            incentiveType: "Hit & Win",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2023-10-15T00:00:00",
            status: 1,
        },
        {
            id: 43,
            campaignId: "330",
            jobRole: "",
            campaignName: "Q2 Mechanical Parts Incentive",
            campaignType: "Incentive",
            description:
                "Top the leaderboard this Quarter and earn a staggering £450 with Mechanical Parts!",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${FullThrottleCamp}`,
            incentiveType: "Hit & Win",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2023-10-15T00:00:00",
            status: 1,
        },
        {
            id: 42,
            campaignId: "318",
            jobRole: "",
            campaignName: "Q2 Service Advisor Wear & Tear Incentive",
            campaignType: "Incentive",
            description:
                "Get ready for a chance to rack up £40 a month in Équipe points and snag a £500 star prize!",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${QtwoCampaign}`,
            incentiveType: "Hit & Win",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2023-10-15T00:00:00",
            status: 1,
        },
        {
            id: 41,
            campaignId: "315",
            jobRole: "",
            campaignName: "Service Manager Wear & Tear Incentive",
            campaignType: "Incentive",
            description:
                "This Campaign is now closed and the winner is being contacted",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${WearTearSm}`,
            incentiveType: "Hit & Win",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2023-10-15T00:00:00",
            status: 1,
            closed: true,
        },
        // {
        //     id: 32,
        //     campaignId: "317",
        //     jobRole: "",
        //     campaignName: "Get your Golden Ticket to success",
        //     campaignType: "Incentive",
        //     description:
        //         "Surprise! Chance to earn £100 Bonus reward in March for Service Managers",
        //     endDate: "2024-08-31T00:00:00",
        //     imageUrl: `${GoldTickets}`,
        // },
        {
            id: 32,
            campaignId: "316",
            jobRole: "",
            campaignName: "Castrol MotoGP Incentive",
            campaignType: "Incentive",
            description:
                "A chance to Join the Global winners in Valencia, Spain, and get treated like a VIP at the MotoGP!",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${CastrolMotoGp}`,
        },
        {
            id: 30,
            campaignId: "125",
            jobRole: "",
            campaignName: "Castrol WINsdays",
            campaignType: "Incentive",
            description:
                "Win up to £50 in points PLUS the chance to win £100 airbnb vouchers!",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${SpinWinCampaignBanner}`,
            incentiveType: "Hit & Win",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2023-10-15T00:00:00",
            status: 1,
        },
        {
            id: 28,
            campaignId: "128",
            jobRole: "",
            campaignName: "Service Stars 2025",
            campaignType: "Incentive",
            description:
                "Stand out amongst the best of the network and earn up to £2,000 in tax free reward points.",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${ServiceStarsCampBanner}`,
            incentiveType: "Hit & Win",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2023-10-15T00:00:00",
            status: 1,
        },
        

        {
            id: 31,
            campaignId: "314",
            jobRole: "",
            campaignName: "Trade Parts Manager Incentive 2025",
            campaignType: "Incentive",
            description:
                "Earn a whopping £225 each quarter when you hit Diamond!",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${TradePartsManagerImg}`,
        },
        {
            id: 29,
            campaignId: "313",
            jobRole: "",
            campaignName: "February Wear & Tear Incentive",
            campaignType: "Incentive",
            description:
                "The campaign is now closed and final results have been published",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${WearTearFebImg}`,
            incentiveType: "Hit & Win",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2023-10-15T00:00:00",
            status: 1,
            closed: true,
        },
      
        {
            id: 0,
            campaignId: "300",
            jobRole: "",
            campaignName: "Wear and Tear Abu Dhabi Incentive",
            campaignType: "Incentive",
            description:
                "The campaign is now CLOSED and final results have been published.",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${Slide02}`,
            incentiveType: "Hit & Win",
            isApproved: true,
            rating: 0,
            ratingCount: 0,
            startDate: "2023-10-15T00:00:00",
            status: 1,
            closed: true,
        },
        {
            id: 32,
            campaignId: "278",
            jobRole: "",
            campaignName: "TLC Gold Rush",
            campaignType: "Incentive",
            description:
                "Boost Engagement & Drive Rewards: Your Guide to Tracking and Maximising Customer Participation in the Monthly Trade Loyalty Club Incentive!",
            endDate: "2024-08-31T00:00:00",
            imageUrl: `${TradePartsTlc}`,
        },
  
    ];

    const UiCampaignSliderMobile = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <UiNextArrow />,
        prevArrow: <UiPrevArrow />,
    };

    const UiCampaignSlider = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: <UiNextArrow />,
        prevArrow: <UiPrevArrow />,
    };

    const readMore = (id, type) => {
        if (type == "Quiz") {
            localStorage.setItem(
                LOCATION_FROM,
                routeLocationLocalStorage.CAMPAIGN,
            );
            navigate("/app/learn/" + id);
        } else if (type == "Comms") {
            navigate("/app/campaigns/comms/" + id);
        } else {
            navigate("/app/campaigns/" + id);
        }
    };

    const AlpineCampaigns = [
        {
            id: 29,
            campaignId: "130",
            campaignName:
                "Service Manager Incentive : Alpine Customer Excellence",
            campaignType: "Prize Draw",
            description:
                "Earn 3,000 Équipe points (£30) for every 5-star rating you receive from an Alpine aftersales customer!",
            endDate: "2024-08-31T00:00:00",
            imageUrl: AlpineCustomer,
            incentiveType: "",
            isApproved: false,
            rating: 0,
            ratingCount: 0,
            startDate: "2023-10-01T00:00:00",
            status: 2,
        },
    ];
  

    const AreaManagerCampaignId = [
        "300",
        "290",
        "270",
        "260",
        "280",
        "125",
        "128",
        "325",
        "130",
        "313",
        "314",
        "316",
        "315",
        "318",
        "278",
        "130",
        "330"
    ];
    const SuperAreaManagerCampaignId = [
        "300",
        "290",
        "270",
        "260",
        "280",
        "125",
        "128",
        "130",
        "313",
        "314",
        "315",
        "316",
        "318",
        "278",
        "330",
        "360"
    ];
    const ServiceManagerHideCampaignId = ["314", "278","330"];
    const visibleUserId = [
        2000038, 2000110, 2000152, 2000599, 2000319, 2000085, 2000382, 2000164,
        2000104, 2000069, 2000035, 2000034, 1000001, 2000588, 2000670, 2000669,
    ];
    const visibleAlpineUsers = [
        2000071, 2000107, 2000072, 2000093, 2000601, 2000120, 2000319, 2000130,
        2000073, 2000112, 2000647, 2000178, 2000105, 2000069, 2000068, 2000109,
        2000038, 2000035, 2000034, 1000001, 2000588, 2000673, 2000674, 2000671,
    ];

    const displayCampaign = (jobRoleId, userId) => {
        if (
            jobRoleId ===
                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR &&
            auth?.userProfileDetails.roleId == participantTypeIds.PARTICIPANT
        ) {
          
            if (visibleAlpineUsers.includes(userId)) {
                campaignServices.splice(2, 0, ...AlpineCampaigns);
            }
            return campaignServices;
        }
        if (
            jobRoleId ===
                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER &&
            auth?.userProfileDetails.roleId == participantTypeIds.PARTICIPANT
        ) {
           
            if (visibleAlpineUsers.includes(userId)) {
                campaigns.splice(5, 0, ...AlpineCampaigns);
            }
            return campaigns.filter(
                (campaigns) =>
                    !ServiceManagerHideCampaignId.includes(
                        campaigns.campaignId,
                    ),
            );
        }
        if (
            jobRoleId ===
                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER &&
            auth?.userProfileDetails.roleId == participantTypeIds.PARTICIPANT &&
            auth?.userProfileDetails?.area !== "0"
        ) {
           
            if (visibleAlpineUsers.includes(userId)) {
                campaigns.splice(5, 0, ...AlpineCampaigns);
            }
            return campaigns.filter((campaign) =>
                AreaManagerCampaignId.includes(campaign.campaignId),
            );
        }

        if (
            jobRoleId === participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER 
        ) {
           
            if (visibleAlpineUsers.includes(userId)) {
                campaigns.splice(5, 0, ...AlpineCampaigns);
            }
            return campaigns.filter((campaign) =>
                SuperAreaManagerCampaignId.includes(campaign.campaignId),
            );
        }

        if (
            (jobRoleId === participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER ||  jobRoleId === participantJobRoleIds.TLC_TRADE_REP) &&
            auth?.userProfileDetails.roleId ==
                participantTypeIds.TLC_PARTICIPANT
        ) {
            return tlcManagerCampaigns;
        }

        if (
            jobRoleId === participantJobRoleIds.TLC_PARTICIPANT_CUSTOMER &&
            auth?.userProfileDetails.roleId ==
                participantTypeIds.TLC_PARTICIPANT
        ) {
            return tlcCustomerCampaigns;
        }

        if (
            jobRoleId ===
                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_TRADE_PARTS_MANAGER &&
            auth?.userProfileDetails.roleId == participantTypeIds.PARTICIPANT
        ) {
            return tradePartsManagerCampaigns;
        }

        return [];
    };

    return (
        <>
            <UiContentWr>
                <UiRowContainer fluid="fluid">
                    <UiCol lg="12" xl="12">
                        <UiContentColWithSlider>
                            <UiColTitleWr id="Lastest-campaigns">
                                <UiColTitle title="Campaigns " />
                            </UiColTitleWr>

                            <div className="sb-campaigns-slider sb-latest-campaign-slider">
                                <UiSlider
                                    UiSliderSettings={
                                        isMobile
                                            ? UiCampaignSliderMobile
                                            : UiCampaignSlider
                                    }
                                >
                                    {auth?.userProfileDetails.jobRoleId &&
                                        displayCampaign(
                                            auth?.userProfileDetails?.jobRoleId,
                                            auth?.userProfileDetails?.userId,
                                        ).map((campaign, id) => (
                                            <div
                                                key={id}
                                                onClick={() =>
                                                    readMore(
                                                        campaign.campaignId,
                                                        campaign.campaignType,
                                                    )
                                                }
                                            >
                                                <UiRowContainer>
                                                    <UiCol lg="12">
                                                        <UiContentCard
                                                            key={id}
                                                            campaignClosed={
                                                                campaign.closed
                                                            }
                                                            cardImg={
                                                                campaign.imageUrl
                                                            }
                                                            heading={
                                                                campaign.campaignName
                                                            }
                                                            jobRole={
                                                                campaign.jobRole
                                                            }
                                                            latestCampaign
                                                            body={
                                                                campaign.description
                                                            }
                                                            // readMore={() =>
                                                            //     readMore(
                                                            //         campaign.campaignId,
                                                            //         campaign.campaignType,
                                                            //     )
                                                            // }
                                                            type={
                                                                cardTypes.CAMPAIGN
                                                            }
                                                            // points={campaign.rating}
                                                        />
                                                    </UiCol>
                                                </UiRowContainer>
                                            </div>
                                        ))}
                                </UiSlider>
                                {campaigns.length > 3 && (
                                    <div className="sb-campaigns-slider__fade-out"></div>
                                )}
                            </div>
                        </UiContentColWithSlider>
                    </UiCol>
                </UiRowContainer>
            </UiContentWr>
        </>
    );
}
